import { createNullableProvideInject } from '@collector/shared-ui'

import { AsideConfig } from '../configuration'

export const [provideAsideConfig, injectAsideConfig] =
  createNullableProvideInject<AsideConfig>('asideConfig')
